import { handleClickOutside } from "./helpers/click-outside-handler";
import { removeOpenedClass } from "./helpers/remove-opened-class";

const BurgerMenu = () => {
  const body = document.body;
  const openers = [...document.querySelectorAll(".header__burger-opener")];
  const burgerMenu = document.querySelector(".burger-menu");
  const closer = document.querySelector(".burger-menu__closer");

  if(burgerMenu){
    const openableLinks = [...burgerMenu.querySelectorAll(".navigation-menu__openable-link")];
    const rightAdditionalLinks = [...burgerMenu.querySelectorAll(".navigation-menu__additional-links-wrapper")];
  
    const secondPart = burgerMenu.querySelector(".second-part");
  
    if (secondPart) {
      const openableItems = [...secondPart.querySelectorAll(".second-part__item.openable")];
  
      openableItems.forEach((openableItem) => {
        openableItem.addEventListener("click", (e) => {
          if (openableItem.classList.contains("opened")) {
            e.preventDefault();
          }
        })
      });
  
  
    }
  
    if (openableLinks.length > 0) {
      openableLinks.forEach((openableLink) => {
        openableLink.addEventListener("click", (e) => {
          e.preventDefault();
  
          openableLinks.forEach((l) => {
            l.classList.remove("opened");
          });
  
          openableLink.classList.add("opened");
          const linkValue = openableLink.getAttribute('data-link');
              
          const matchingRightAdditionalLinks = rightAdditionalLinks.find((link) => link.getAttribute('data-link') === linkValue);
          if (matchingRightAdditionalLinks) {
            rightAdditionalLinks.forEach((rightAdditionalLink) => {
              rightAdditionalLink.classList.remove("active");
            })
  
            matchingRightAdditionalLinks.classList.add("active");
          }
        });
      });
    };
    
    const openBurgerMenu = () => {
      burgerMenu.classList.add("opened");
      body.classList.add("no-scroll");
      removeOpenedClass(burgerMenu);
  
      handleClickOutside([burgerMenu, ...openers], closeBurgerMenu);
    }
  
    const closeBurgerMenu = () => {
      burgerMenu.classList.remove("opened");
      body.classList.remove("no-scroll");
    }
    
    if (openers.length > 0) {
      openers.forEach((opener) => {
        opener.addEventListener("click", openBurgerMenu);
      })
    }
  
    if (closer) {
      closer.addEventListener("click", closeBurgerMenu);
    }
  }
}

export default BurgerMenu;



